export default {"src":"https://webcdn.trailways.com/_next/static/media/time-primary.33cad0bd.svg","height":17,"width":16,"blurWidth":0,"blurHeight":0};